import { PopoverContent } from "../ui/popover";
import { Button } from "../ui/button";
import { HandleRowKeyActionParams } from "../../hooks/templateV2/types";
import { z } from "zod";
import { rowKeysValidator } from "../../models/schemasV2";
import { useCallback, useState } from "react";
import { Input } from "../ui/input";
import { PopoverClose } from "@radix-ui/react-popover";
import { toast } from "sonner";
import { TrashIcon } from "lucide-react";
import { Textarea } from "../ui/textarea";
import { Switch } from "../ui/switch";
interface RowKeyPopoverProps {
  rowKey?: z.infer<typeof rowKeysValidator>;
  handleRowKeyAction: (params: HandleRowKeyActionParams) => void;
  tableId: string;
}

export const RowKeyPopover = ({
  tableId,
  rowKey,
  handleRowKeyAction,
}: RowKeyPopoverProps) => {
  const [rowKeyName, setRowKeyName] = useState<string>(rowKey?.name || "");
  const [rowKeyDescription, setRowKeyDescription] = useState<string>(
    rowKey?.description || "",
  );
  const [rowKeyRequired, setRowKeyRequired] = useState<boolean>(
    rowKey?.required || false,
  );
  const isEditMode = !!rowKey;

  const handleDelete = useCallback(() => {
    if (rowKey && rowKey.tableId) {
      handleRowKeyAction({
        deleteRowKey: true,
        rowKeyDescription: rowKey.description || "",
        tableId: tableId,
        rowKeyId: rowKey.id,
        rowKeyName: rowKey.name,
        rowKeyRequired: rowKeyRequired,
      });
    } else {
      toast.error("Row key not found");
    }
  }, [rowKey, handleRowKeyAction, tableId, rowKeyRequired]);

  const handleSave = useCallback(() => {
    if (rowKeyName) {
      handleRowKeyAction({
        rowKeyId: isEditMode ? rowKey?.id : undefined,
        deleteRowKey: false,
        tableId: tableId,
        rowKeyName: rowKeyName,
        rowKeyDescription: rowKeyDescription,
        rowKeyRequired: rowKeyRequired,
      });
    }
  }, [
    isEditMode,
    rowKey,
    handleRowKeyAction,
    tableId,
    rowKeyName,
    rowKeyDescription,
    rowKeyRequired,
  ]);

  return (
    <PopoverContent align="start" className="w-[500px]">
      <div className="flex flex-col gap-2">
        {isEditMode && (
          <PopoverClose asChild>
            <div className="flex justify-end">
              <TrashIcon
                className="cursor-pointer"
                onClick={handleDelete}
                size={16}
              />
            </div>
          </PopoverClose>
        )}
        <label htmlFor="rowKeyName" className="text-sm">
          Row Key Name
        </label>
        <Input
          placeholder="Row Key Name"
          type="text"
          id="rowKeyName"
          onChange={(e) => setRowKeyName(e.target.value)}
          value={rowKeyName}
        />
        <label htmlFor="rowKeyDescription" className="text-sm">
          AI Instructions (Optional)
        </label>
        <Textarea
          placeholder="AI Instructions"
          id="rowKeyDescription"
          onChange={(e) => setRowKeyDescription(e.target.value)}
          value={rowKeyDescription}
        />
        <div className="flex items-center space-x-2 my-2">
          <Switch
            id="required"
            checked={rowKeyRequired}
            onCheckedChange={(checked) => setRowKeyRequired(checked)}
          />
          <label htmlFor="required" className="text-sm">
            Required
          </label>
        </div>
        <PopoverClose asChild>
          <Button onClick={handleSave}>Save</Button>
        </PopoverClose>
      </div>
    </PopoverContent>
  );
};
